(function() {
  var TR = {
    'Pick a delivery date that works best for you': 'Size en uygun teslimat tarihini seçin',
    'Store pickup': 'Mağazadan Teslim',
    'Local delivery': 'Eve Teslimat',
    'Choose the nearest location for your pickup': 'Teslim noktasını seçin',
    'Postal code': 'Posta Kodu',
    'Check': 'Kontrol Et',
    'Local delivery is available in your area': 'Bölgenize teslimat yapıyoruz ✓',
    'Local delivery is not available in your area': 'Üzünüz, bölgenize teslimat yapamıyoruz',
    'Local delivery date': 'Teslimat Tarihi',
    'Local delivery time': 'Teslimat Saati',
    'Pickup date': 'Teslim Tarihi',
    'Pickup time': 'Teslim Saati',
    'Please choose a delivery date and time before checkout': 'Lütfen ödemeye geçmeden önce teslimat tarihi ve saatini seçin',
    'Please choose a pickup date and time before checkout': 'Lütfen ödemeye geçmeden önce teslim tarihi ve saatini seçin',
    'Please fill in all required fields marked': 'Lütfen zorunlu alanları doldurun',
  };

  function translateTextNodes(root) {
    if (!root || !root.querySelectorAll) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while (node = walker.nextNode()) {
      var orig = node.textContent.trim();
      if (orig && TR[orig]) node.textContent = node.textContent.replace(orig, TR[orig]);
    }
    root.querySelectorAll("[placeholder]").forEach(function(el) {
      if (TR[el.placeholder]) el.placeholder = TR[el.placeholder];
    });
    root.querySelectorAll(".ot-dingdoong-minimum-order-amount-error").forEach(function(el) {
      if (el.textContent.includes('local delivery')) {
        el.textContent = 'Eve teslimat için minimum sipariş tutarı: 0 TL';
      } else if (el.textContent.includes('pickup')) {
        el.textContent = 'Mağazadan teslim için minimum sipariş tutarı: 0 TL';
      }
    });
  }

  function translateAll() {
    document.querySelectorAll("[class*=\"ot-dingdoong\"]").forEach(translateTextNodes);
    document.querySelectorAll(".ot-dingdoong-minimum-order-amount-error").forEach(function(el) {
      if (el.textContent.includes('local delivery')) {
        el.textContent = 'Eve teslimat için minimum sipariş tutarı: 0 TL';
      } else if (el.textContent.includes('pickup')) {
        el.textContent = 'Mağazadan teslim için minimum sipariş tutarı: 0 TL';
      }
    });
  }

  var DISTRICTS = [
    { name: 'Ataşehir',   code: '34750' },
    { name: 'Bayrampaşa', code: '34050' },
    { name: 'Beşiktaş',   code: '34330' },
    { name: 'Beyoğlu',    code: '34421' },
    { name: 'Fatih',      code: '34080' },
    { name: 'Kağıthane',  code: '34400' },
    { name: 'Kadıköy',    code: '34704' },
    { name: 'Şişli',      code: '34363' },
    { name: 'Üsküdar',    code: '34660' },
    { name: 'Ümraniye',   code: '34760' }
  ];

  function buildSelector(deliveryEl) {
    if (deliveryEl.dataset.dosDistrict) return;
    var zipcodeInput = deliveryEl.querySelector(".ot-dingdoong-delivery__zipcode-input");
    var submitBtn = deliveryEl.querySelector("button");
    var label = deliveryEl.querySelector(".ot-dingdoong-delivery__label");
    if (!zipcodeInput || !submitBtn) return;
    deliveryEl.dataset.dosDistrict = '1';
    if (label) label.textContent = 'Teslimat bölgenizi seçin';
    var wrapper = deliveryEl.querySelector(".ot-dingdoong-delivery__zipcode-wrapper");
    if (wrapper) wrapper.style.display = "none";
    var container = document.createElement("div");
    container.style.cssText = "margin:8px 0 12px;";
    var select = document.createElement("select");
    select.style.cssText = "width:100%;padding:10px 14px;font-size:14px;border:1px solid #d8d0c8;border-radius:4px;background:white;color:#333;cursor:pointer;font-family:inherit;";
    var defOpt = document.createElement("option");
    defOpt.value = ''; defOpt.textContent = '— İlçe seçin —';
    select.appendChild(defOpt);
    DISTRICTS.forEach(function(d) {
      var opt = document.createElement("option");
      opt.value = d.code; opt.textContent = d.name;
      select.appendChild(opt);
    });
    select.addEventListener("change", function() {
      if (!this.value) return;
      var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
      setter.call(zipcodeInput, this.value);
      zipcodeInput.dispatchEvent(new Event('input', { bubbles: true }));
      zipcodeInput.dispatchEvent(new Event('change', { bubbles: true }));
      var btn = submitBtn;
      setTimeout(function() { btn.click(); }, 150);
    });
    container.appendChild(select);
    if (wrapper) { deliveryEl.insertBefore(container, wrapper); }
    else { deliveryEl.insertBefore(container, submitBtn); }
  }

  var scanning = false;
  var pendingScan = false;

  function scan() {
    if (scanning) { pendingScan = true; return; }
    scanning = true;
    observer.disconnect();
    try {
      document.querySelectorAll(".ot-dingdoong-delivery").forEach(buildSelector);
      translateAll();
    } finally {
      scanning = false;
      observer.observe(document.body, { childList: true, subtree: true });
      if (pendingScan) { pendingScan = false; setTimeout(scan, 100); }
    }
  }

  var observer = new MutationObserver(function() {
    if (!scanning) setTimeout(scan, 50);
  });
  observer.observe(document.body, { childList: true, subtree: true });
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else { scan(); }
})();